import { useFormContext } from 'react-hook-form'
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { Switch } from '@/components/ui/switch'
import { SectorFormValues } from './SectorSchema'

export const FormConfigTab = () => {
  const form = useFormContext<SectorFormValues>()

  return (
    <div className="space-y-6">
      <div className="space-y-4">
        <h3 className="font-semibold text-sm uppercase tracking-wider text-slate-500 border-b pb-2">
          Lead Form Configuration
        </h3>

        <FormField
          control={form.control}
          name="show_uses_excel"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-base">
                  Ask about Excel usage?
                </FormLabel>
                <FormDescription>
                  Show/hide the "Do you use Excel?" question.
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="show_employee_count"
          render={({ field }) => (
            <FormItem className="flex flex-row items-center justify-between rounded-lg border p-4">
              <div className="space-y-0.5">
                <FormLabel className="text-base">Ask Employee Count?</FormLabel>
                <FormDescription>
                  Show/hide the employee count dropdown.
                </FormDescription>
              </div>
              <FormControl>
                <Switch
                  checked={field.value}
                  onCheckedChange={field.onChange}
                />
              </FormControl>
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="custom_challenge_label"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Custom Challenge Label</FormLabel>
              <FormControl>
                <Input
                  placeholder="e.g. What is your main logistics bottleneck?"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                Override the default "What is your main challenge?" question.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
    </div>
  )
}
